/** The strings for this feature, in the active language — see src/lib/i18n.js. */
import { pickLocale } from '../lib/i18n'
import * as ar from './strings.ar'
import * as en from './strings.en'

export const common = pickLocale(ar.common, en.common)
export const outcome = pickLocale(ar.outcome, en.outcome)
export const shell = pickLocale(ar.shell, en.shell)
export const warnings = pickLocale(ar.warnings, en.warnings)
export const gate = pickLocale(ar.gate, en.gate)
export const dashboard = pickLocale(ar.dashboard, en.dashboard)
export const courses = pickLocale(ar.courses, en.courses)
export const courseDetails = pickLocale(ar.courseDetails, en.courseDetails)
export const exam = pickLocale(ar.exam, en.exam)
export const examHistory = pickLocale(ar.examHistory, en.examHistory)
export const awareness = pickLocale(ar.awareness, en.awareness)
export const policies = pickLocale(ar.policies, en.policies)
export const assessments = pickLocale(ar.assessments, en.assessments)
export const surveys = pickLocale(ar.surveys, en.surveys)
export const reports = pickLocale(ar.reports, en.reports)
export const leaderboard = pickLocale(ar.leaderboard, en.leaderboard)
export const profile = pickLocale(ar.profile, en.profile)
export const contact = pickLocale(ar.contact, en.contact)
export const certificates = pickLocale(ar.certificates, en.certificates)
export const manual = pickLocale(ar.manual, en.manual)
export const terms = pickLocale(ar.terms, en.terms)
